export default "__VITE_ASSET__DVHGpmdT__"